"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  IconButton: true
};
exports.default = exports.IconButton = void 0;
var _react = _interopRequireDefault(require("react"));
var _AddChildPropsContext = require("../utils/_AddChildPropsContext");
var _Icon = require("../Icon/Icon");
var _Button = require("../Buttons/Button");
var _Tooltip = require("../Tooltip/Tooltip");
var _IconButton = require("./IconButton.types");
Object.keys(_IconButton).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _IconButton[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _IconButton[key];
    }
  });
});
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
/**
 * **IconButton** is specialized button component that only allows an
 * icon for the button content.  Since the button only contains an icon,
 * it is wrapped with a **Tooltip** to improve the accessibility.
 *
 * > **IconButton** and **IconLink** components are sometimes used interchangeably,
 * but from an accessibility perspective, there are specific use cases for each.
 * Please see [Design Usage for Link Button and Link](./?path=/docs/design-buttons--docs)
 * for the distinction between the two and proper usage.
 */
const IconButton = exports.IconButton = /*#__PURE__*/_react.default.forwardRef((_props, ref) => {
  const addChildProps = (0, _AddChildPropsContext.useAddChildProps)();
  const props = addChildProps ? Object.assign(Object.assign({}, _props), addChildProps(IconButton, _props)) : _props;
  const {
      ariaLabel,
      children,
      forceSize,
      iconName,
      iconProps,
      tooltipDelay = 300,
      tooltipMsg,
      tooltipProps,
      inToolbarOverflow,
      type = 'link'
    } = props,
    otherProps = __rest(props, ["ariaLabel", "children", "forceSize", "iconName", "iconProps", "tooltipDelay", "tooltipMsg", "tooltipProps", "inToolbarOverflow", "type"]);
  const hideTooltip = tooltipDelay < 0;
  let buttonContent = /*#__PURE__*/_react.default.createElement(_Button.Button, Object.assign({}, otherProps, {
    "aria-label": ariaLabel,
    ref: ref,
    type: type,
    hideCreateIcon: true,
    forceSize: forceSize
  }), /*#__PURE__*/_react.default.createElement(_Icon.Icon, Object.assign({}, iconProps, {
    ariaHidden: true,
    iconName: iconName
  })), children);
  if (inToolbarOverflow) {
    buttonContent = /*#__PURE__*/_react.default.createElement(_Button.Button, Object.assign({}, otherProps, {
      type: type,
      ref: ref,
      inToolbarOverflow: true,
      hideCreateIcon: true
    }), /*#__PURE__*/_react.default.createElement(_Icon.Icon, Object.assign({}, iconProps, {
      ariaHidden: true,
      iconName: iconName
    })), ariaLabel);
  }
  if (!hideTooltip && !inToolbarOverflow) {
    const ariaLabelSameAsTooltip = !tooltipMsg || tooltipMsg === ariaLabel;
    buttonContent = /*#__PURE__*/_react.default.createElement(_Tooltip.Tooltip, Object.assign({
      "aria-hidden": true,
      placement: ['top', 'bottom']
    }, tooltipProps, {
      delay: tooltipDelay,
      message: tooltipMsg || ariaLabel,
      doNotDescribe: ariaLabelSameAsTooltip
    }), buttonContent);
  }
  return /*#__PURE__*/_react.default.createElement(_AddChildPropsContext.AddChildPropsProvider, {
    value: null
  }, buttonContent);
});
IconButton.displayName = 'IconButton';
var _default = exports.default = IconButton;